import { useRecordContext, useTranslate } from "ra-core";

import { Avatar } from "../contacts/Avatar";
import type { Contact } from "../types";

// eslint-disable-next-line react-refresh/only-export-components
const ContactOptionRender = () => {
  const record: Contact | undefined = useRecordContext();
  const translate = useTranslate();
  if (!record) return null;
  return (
    <div className="flex flex-row gap-4 items-center justify-start whitespace-normal text-left">
      <Avatar height={40} width={40} record={record} />
      <div className="flex flex-col items-start gap-1">
        <span>
          {record.academic_title ? `${record.academic_title} ` : ""}{record.first_name} {record.last_name}
        </span>
        <span className="text-xs text-muted-foreground">
          {record.title && record.company_name
            ? translate("resources.contacts.position_at_company", {
                title: record.title,
                company: record.company_name,
              })
            : record.title || record.company_name}
        </span>
      </div>
    </div>
  );
};
export const contactOptionText = <ContactOptionRender />;
